import { render, staticRenderFns } from "./Academics.vue?vue&type=template&id=44a01580&scoped=true&"
import script from "./Academics.vue?vue&type=script&lang=js&"
export * from "./Academics.vue?vue&type=script&lang=js&"
import style0 from "./Academics.vue?vue&type=style&index=0&id=44a01580&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a01580",
  null
  
)

export default component.exports